<div class="scrollbar app">
    <div class="row">
    <div class="col-3 af-form-group">
        <label for="mechanic" translate>lblEfficiency<strong class="mlt6 required"> * </strong></label>
            <div class="lbl-info">
            <input class="form-control mb-2" maxlength="5" required [(ngModel)]="efficiency"  #efficiencyvar="ngModel" (keypress)="isPrice($event)">
            </div>
            <div *ngIf="efficiencyvar.invalid && (efficiencyvar.dirty || efficiencyvar.touched)" class="help-block text-danger">
                    <span translate>lblEfficiencyRequired</span>
            </div>
    </div>
        <div class="col-12 af-form-group">
            <label translate>lblSkillDescription</label>
            <div class="lbl-info">
                <textarea class="form-control" cols="20" rows="3" maxlength="100" name="skillDescription" [(ngModel)]='skillDescription'></textarea>
            </div>
        </div>
        <div class="col-12">
            <div *ngFor="let editMechanicCompetence of EditMechanicCompetenceForm; let in=index;let last=last">
                <form name="form{{in}}" #f="ngForm">
                    <div class="row">
                        <!--competence name-->
                        <div class='col-3 af-form-group'>
                            <label translate>lblSelectCompetenceName <span class="required">*</span></label>
                            <div class='lbl-info'>
                                <select class="form-control" [(ngModel)]="editMechanicCompetence.competenceId" name="competenceName{{in}}" (change)="competenceNameSelected($event.target.value,in)" id="Add-CompetenceName{{in}}" #competenceName="ngModel" [class.in-invalid]="competenceName.isvalid && competenceName.touched"
                                    required>
                    <option selected disabled [ngValue]="null" translate>lblSelectCompetenceName</option>
                    <option *ngFor="let competence of competenceActiveList" [(ngValue)]="competence.id">
                      {{competence.name}}
                    </option>
                  </select>
                                <div *ngIf="competenceName.touched && competenceName.errors?.required" class="help-block text-danger">
                                    <span translate>lblPleaseSelectCompetence</span>
                                </div>
                            </div>
                        </div>

                        <!--Brand Dropdown-->
                        <div class='col-3 af-form-group'>
                            <label translate>lblSelectBrand <span class="required">*</span></label>
                            <div class='lbl-info'>
                                <app-multiselector-dropdown-brand name="brandName{{in}}" id="Add-Brand{{in}}" [list]="brandList[in]" [index]="in" (shareBrandCheckedList)="shareBrandCheckedList($event)">
                                </app-multiselector-dropdown-brand>
                            </div>
                        </div>

                        <!--Vehicle Type Dropdown-->
                        <div class='col-3 af-form-group'>
                            <label translate>lblVehicleType <span class="required">*</span></label>
                            <div class="lbl-info">
                                <app-multiselector-dropdown-vehicle-type name="vehicleTypeName{{in}}" id="Add-VehicleType{{in}}" [list]="vehicleTypeList[in]" [index]="in" (shareVehicleTypeCheckedList)="shareVehicleTypeCheckedList($event)">
                                </app-multiselector-dropdown-vehicle-type>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="col-3">
                            <div class="mt-4">
                                <button type="submit" class="btn btn-secondary mr-sm-2 mt-1" aria-label="Center Align" (click)="RemoveMechanicCompetence(in)" *ngIf="EditMechanicCompetenceForm.length>1" translate><em class="fas fa-minus"></em>
                  </button>
                                <button type="submit" class="btn btn-primary mr-sm-2 mt-1" aria-label="Center Align" [disabled]="!editMechanicCompetence.competenceId || editMechanicCompetence.brandId?.length<1 || editMechanicCompetence.vehicleTypeId?.length<1" #addButton (click)="AddMechanicCompetence(editMechanicCompetence,in)"
                                    *ngIf="last" translate><em class="fas fa-plus"></em>
                  </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
      <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" [disabled]="!efficiency" aria-label="Center Align" (click)="submitForm(false)" translate>lblSaveChanges</button>
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" [disabled]="!efficiency" aria-label="Center Align" (click)="submitForm(true)" translate>lblSaveAndClose</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblBack</a>
        </div>
    </div>
</div>